import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadOlderMessagesProps {
  hasOlderMessages: boolean;
  isLoading: boolean;
  onLoadOlder: () => void;
  className?: string;
}

export const LoadOlderMessages: React.FC<LoadOlderMessagesProps> = ({
  hasOlderMessages,
  isLoading,
  onLoadOlder,
  className
}) => {
  if (!hasOlderMessages && !isLoading) {
    return null;
  }

  return (
    <div className={cn(
      "flex justify-center py-4",
      className
    )}>
      <Button
        variant="ghost"
        size="sm"
        onClick={onLoadOlder}
        disabled={isLoading}
        className="text-white bg-destructive hover:bg-destructive/90 backdrop-blur-sm border border-border/50"
      >
        {isLoading ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Carregando...
          </>
        ) : (
          <>
            <ChevronUp className="h-4 w-4 mr-2" />
            Carregar mensagens mais antigas
          </>
        )}
      </Button>
    </div>
  );
};